import { connect } from "react-redux";
import React from "react";

// react component for creating dynamic tables
import ReactTable from "react-table";
import SweetAlert from "react-bootstrap-sweetalert";
import Tooltip from '@material-ui/core/Tooltip';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import Close from "@material-ui/icons/Close";
import People from "@material-ui/icons/People";
import Add from "@material-ui/icons/PersonAdd";


// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardHeader from "components/Card/CardHeader.jsx";


import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx";
import { fetchCompaniesRequest, suspendCompanyRequest, SuspendCompanyReset } from "../../../actions/company"



const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  }
};

const successButtonStyle = {backgroundColor: "#4CAF50", /* Green */
      border: "none",
      color: "white",
      padding: "15px 32px",
      textAlign: "center",
      textDecoration: "none",
      display: "inline-block",
      fontSize: "16px"}

      const dangerButtonStyle = {backgroundColor: "red", /* Green */
      border: "none",
      color: "white",
      padding: "15px 32px",
      textAlign: "center",
      textDecoration: "none",
      display: "inline-block",
      fontSize: "16px"}

class ViewCompanies extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: "",
      alert: null
  }
}

componentWillMount() {
  this.props.dispatch(fetchCompaniesRequest());
} 
suspendCompany(company){
  console.log("Are you sure you want to suspend company: ", company.comapanyName);
  this.props.dispatch(suspendCompanyRequest(company._id))
  this.hideAlert()
}
suspendWarningAlert(company) {
  const companyName = company.comapanyName
  this.setState({
    alert: (
      <SweetAlert
        warning
        style={{ display: "block", marginTop: "-100px" }}
        title="Are you sure?"
        onConfirm={() => this.suspendCompany(company)}
        onCancel={() => this.cancelSuspendAlert()}
        confirmBtnStyle={successButtonStyle}
        cancelBtnStyle={dangerButtonStyle}
        confirmBtnText="Yes, suspend it!"
        cancelBtnText="Cancel"
        showCancel
      >
        <p style={{fontSize:"20px"}}>You want to suspend {companyName}!</p>
      </SweetAlert>
    )
  });
}

cancelSuspendAlert() {
  this.setState({
    alert: (
      <SweetAlert
        danger
        style={{ display: "block", marginTop: "-100px" }}
        title="Cancelled"
        onConfirm={() => this.hideAlert()}
        onCancel={() => this.hideAlert()}
        confirmBtnStyle={successButtonStyle}
      >
      </SweetAlert>
    )
  });
}

hideAlert() {
  this.setState({
    alert: null
  });
}

displayErrorFeedback() {
  const e = this.errorMessage()
  return <SweetAlert
    danger
    style={{ display: "block", marginTop: "-100px" }}
    title="Cancelled"
    onConfirm={() => this.reset()}
    onCancel={() => this.reset()}
    confirmBtnStyle={dangerButtonStyle}
  >
    <div>
      {e.map((item, index) => {

        return <div key={index}> {item}</div>
      })}
    </div>
  </SweetAlert>
}

displaySuccessFeedback() {
  return <SweetAlert
  success
  style={{ display: "block", marginTop: "-100px" }}
  title="Suspended!"
  onConfirm={() => this.reset()}
  confirmBtnStyle={successButtonStyle}
>
  Company has been supspended.
</SweetAlert>
}


displayLoader() {
  return <Dialog
    open={true}
    onClose={this.hideAlert}
    aria-labelledby="form-dialog-title"
  >
    <DialogContent>
      <CircularProgress />
    </DialogContent>
  </Dialog>
}

errorMessage() {
  let e = this.props.companyData.suspendCompanyErrors
  if (Array.isArray(e)) {
    let i;
    let el = []
    for (i = 0; i < e.length; i++) {
      let obj = e[i].constraints
      for (var property in obj) {
        el.push(obj[property] + '; ')
      }
    }
    return el

  }
  else if (e.message) {
    return [e.message]
  } else {
    return ["unexpected Error occured"]
  }
}

reset() {
  this.props.dispatch(SuspendCompanyReset())
}
  render() {
    let companies = (this.props.companyData.companies != null) ? this.props.companyData.companies : []
    const { classes } = this.props;
    
    return (
      <GridContainer>
        <div>
          <div style={{ textAlign: "center" }}>
            {this.props.companyData.suspendCompanyErrors ? (this.displayErrorFeedback()) : ('')}
            {this.props.companyData.suspendCompanySuccess ? (this.displaySuccessFeedback()) : ('')}
            {this.props.companyData.suspendCompanyLoader ? (this.displayLoader()) : ('')}
            {this.props.companyData.loader ? (this.displayLoader()) : ('')}

          </div>
        </div>
      {this.state.alert}

        <GridItem xs={12}>
        <center>
          <Button color="info" onClick={() => this.props.history.push('/admin/company')}>
            <Add />
            Register Contractor
          </Button>
          </center>
          <Card>
            <CardHeader color="primary" icon>
              <CardIcon color="info">
                <People />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>List of available contractors</h4>
            </CardHeader>
            <CardBody>
              <ReactTable
                data={companies.map((company, key) => {
                  return {
                    id: key,
                    comapanyName: company.comapanyName,
                    address: company.address,
                    telephone: company.telephone,
                    email: company.email,
                    contactPerson: company.contactPerson,
                    registrationNumber: company.registrationNumber,
                    taxNumber: company.taxNumber,
                    vatNumber: company.vatNumber, 
                    actions: (
                      <div className="actions-right">
                        <Tooltip title="Suspend company" placement="top-start">
                        <Button
                          justIcon
                          round
                          simple
                          onClick={this.suspendWarningAlert.bind(this, company)}
                          color="danger"
                          className="remove"
                        >
                          <Close />
                        </Button>
                        </Tooltip>
                      </div>
                    )
                  };
                })
              }
                filterable
                columns={[
                  {
                    Header: "Name",
                    accessor: "comapanyName"
                  },
                  {
                    Header: "Address",
                    accessor: "address"
                  },
                  {
                    Header: "Telephone",
                    accessor: "telephone"
                  },
                  {
                    Header: "Email",
                    accessor: "email"
                  },
                  {
                    Header: "Contact",
                    accessor: "contactPerson"
                  },
                  {
                    Header: "Reg Number",
                    accessor: "registrationNumber"
                  },
                  {
                    Header: "Tax Number",
                    accessor: "taxNumber"
                  },
                  {
                    Header: "Vat Number",
                    accessor: "vatNumber",
                  },
                  {
                    Header: "Actions",
                    accessor: "actions",
                    sortable: false,
                    filterable: false
                  }
                ]}
                defaultPageSize={30}
                showPaginationTop
                showPaginationBottom={false}
                className="-striped -highlight"
              />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    );
  }
}

export default withStyles(styles)(
  connect(state => ({
    companyData: state.companyState,
  }))(ViewCompanies)
);
